export default __webpack_public_path__ + "static/media/mobile_10.eaf6a964.png";